/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Essay attainment projector: 7-6s with fail below 50%.
 */
export interface GermanLegacyEssayProjector {
  type?: 'german_legacy_essay';
}
